import { replace } from 'lodash';

// v1.22.0
// 后端对独立应用“内容、node”相关操作的权限控制，调用接口时在普通接口上增加{businessConfigUuid}
// 例：
// 普通内容：/api/v1/business_content_{subject}/existed_contents
// 独立应用：/api/v1/business_content_{subject}/{businessConfigUuid}/existed_contents

// 注：独立应用在url的参数中带有 "bizType=independent"

export function authentication(url: string) {
  const { businessConfigUuid } = nx.hashlize();
  if (!url) return url;
  const api = url.match(/(api\S*)\??/g)[0];
  if (
    api.match('api/v1/business_content_') ||
    api.match('api/v1/business_nodes_') ||
    api.match('api/v1/content_')
  ) {
    let _url;
    if (api.match('english/')) {
      if (api.includes('/existed_contents')) return url;
      _url = replace(url, 'english/', `english/${businessConfigUuid}/`);
    } else {
      _url = replace(url, 'english', `english/${businessConfigUuid}`); // 处理这种情况：https://sandbox-kellis-ng.alo7.com/api/v1/business_content_english
    }
    return _url;
  }

  return url;
}
